<div class="em-content">
    <router-outlet></router-outlet>
</div>